<script setup>
import { useI18n } from "vue-i18n";

setAppLocale();

const { locale } = useI18n();

useHead({
  title: "CareDay - Dashboard",
  htmlAttrs: {
    lang: locale.value
  }
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
</style>
